import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";

const delay = (ms) => new Promise((r) => setTimeout(r, ms));

const inputCls =
  "w-full bg-gray-50/60 border border-gray-200 rounded-xl px-4 py-3.5 text-sm text-[#1A1A1A] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#E07A5F]/60 focus:border-transparent transition-[box-shadow,border-color]";

const primaryBtnCls =
  "inline-flex items-center justify-center gap-2 font-semibold text-white rounded-xl bg-gradient-to-r from-[#E07A5F] to-[#E2856E] shadow-[0_4px_14px_rgba(224,122,95,0.39)] hover:shadow-[0_6px_20px_rgba(224,122,95,0.3)] hover:-translate-y-0.5 transition-[box-shadow,transform] disabled:opacity-70 disabled:pointer-events-none";

async function submitLead(payload, onSuccess, reset) {
  try {
    await Promise.all([api.post("/waitlist", payload), delay(1500)]);
    reset();
    onSuccess();
  } catch (err) {
    const detail = err?.response?.data?.detail;
    toast.error(typeof detail === "string" ? detail : "Qualcosa è andato storto. Riprova tra poco.");
    reset(false);
  }
}

// ---------- Bottom CTA full form ----------
export function FullWaitlistForm({ onSuccess }) {
  const [names, setNames] = useState("");
  const [email, setEmail] = useState("");
  const [privacy, setPrivacy] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    if (!privacy) {
      toast.error("Per procedere devi accettare la Privacy Policy.");
      return;
    }
    setLoading(true);
    submitLead(
      {
        couple_names: names,
        email,
        privacy_accepted: privacy,
        source: "full",
      },
      onSuccess,
      (clear = true) => {
        setLoading(false);
        if (clear) {
          setNames("");
          setEmail("");
          setPrivacy(false);
        }
      }
    );
  };

  return (
    <form data-testid="full-waitlist-form" onSubmit={handleSubmit} className="mt-10 space-y-4 text-left">
      <div className="grid sm:grid-cols-2 gap-4">
        <input
          data-testid="full-waitlist-names-input"
          type="text"
          required
          minLength={2}
          value={names}
          onChange={(e) => setNames(e.target.value)}
          placeholder="Nomi della coppia"
          className={inputCls}
        />
        <input
          data-testid="full-waitlist-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className={inputCls}
        />
      </div>
      <label
        htmlFor="privacy-checkbox"
        className="flex items-center gap-3 text-sm text-gray-500 cursor-pointer select-none pt-1"
      >
        <Checkbox
          id="privacy-checkbox"
          data-testid="full-waitlist-privacy-checkbox"
          checked={privacy}
          onCheckedChange={(v) => setPrivacy(v === true)}
          className="border-gray-300 data-[state=checked]:bg-[#E07A5F] data-[state=checked]:border-[#E07A5F]"
        />
        Accetto la{" "}
        <Link
          to="/privacy-policy"
          data-testid="full-waitlist-privacy-link"
          className="underline underline-offset-2 text-gray-600 hover:text-[#C2492F] transition-colors"
        >
          Privacy Policy
        </Link>
      </label>
      <button
        data-testid="full-waitlist-submit-button"
        type="submit"
        disabled={loading}
        className={`${primaryBtnCls} cta-pulse w-full py-4 text-base`}
      >
        {loading && <Loader2 size={18} className="animate-spin" />}
        {loading ? "Invio in corso..." : "Unisciti alla lista d'attesa"}
      </button>
    </form>
  );
}
